
// SVG Icon: maximize
export default { id: "terriajs-maximize" };
export const id = "terriajs-maximize";
export const name = "maximize";
